import {useDataSource} from "src/core/data-sources/decorators/withData";
import ProductsListDataSource from "src/core/products/data-sources/productsList";

function useProductsList({filters, limit, offset, order}) {
  return useDataSource(
    {filters, limit, offset, order},
    {
      dataSource: dataSource,
      dataField: "products",
    }
  );
}

const dataSource = new ProductsListDataSource();

export default useProductsList;
